import React from 'react';
import { useNavigate } from 'react-router-dom';
import NumberDrawer from './NumberDrawer';
import RouletteDrawer from './RouletteDrawer';
import Card from '../../components/ui/Card';

const tools = [
  { title: '번호 추첨기', description: '랜덤으로 번호를 추첨합니다.', path: '/tools/number-draw' },
  { title: '룰렛 추첨기', description: '룰렛을 돌려 당첨자를 선정합니다.', path: '/tools/roulette' },
  {
    title: '손동작 차크라 스튜디오',
    description: '카메라와 AI 손 인식으로 나선환과 치도리 효과를 만들어 봅니다.',
    path: '/tools/hand-chakra',
  },
];

const Tools: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
      <h1 style={{ fontSize: 28, fontWeight: 600, marginBottom: 32, textAlign: 'center' }}>
        교육 도구
      </h1>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
        {tools.map((tool) => (
          <div
            key={tool.path}
            style={{ width: '100%', flex: '1 1 100%', minWidth: 280 }}
          >
            <Card
              style={{ height: '100%', cursor: 'pointer' }}
              onClick={() => navigate(tool.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{ textAlign: 'center', padding: 24 }}>
                <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>{tool.title}</h2>
                <p style={{ fontSize: 14, color: 'var(--Color-text-normal)', margin: 0 }}>
                  {tool.description}
                </p>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tools;
